import { render, staticRenderFns } from "./TableInfiniteDetector.vue?vue&type=template&id=1dc21de8&scoped=true"
import script from "./TableInfiniteDetector.vue?vue&type=script&lang=js"
export * from "./TableInfiniteDetector.vue?vue&type=script&lang=js"
import style0 from "./TableInfiniteDetector.vue?vue&type=style&index=0&id=1dc21de8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc21de8",
  null
  
)

export default component.exports